angular.module('picmonicng').factory('OrdersResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/orders/:orderId/:resource',
      { orderId: '@orderId', resource: '@resource' },
      {
        processOrder: { method: 'POST', isArray: false },
      }
    );
  },
]);
